// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCvMVa5ehmZzwWkMxI5I-dBytDl45HP0AI",
    authDomain: "julio-matamoros.firebaseapp.com",
    databaseURL: "https://julio-matamoros.firebaseio.com",
    projectId: "julio-matamoros",
    storageBucket: "julio-matamoros.appspot.com",
    messagingSenderId: "152447038230",
    appId: "1:152447038230:web:f2e4151ed363d477431637",
    measurementId: "G-8VQL3G8LWZ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
